/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import CampaignModel from 'cio/models/campaign';
import { Periods } from 'cio/utils/metrics/common';
import { DateRange } from '@customerio/fly-components/utils/fly-date-picker-utils';
import { inject as service } from '@ember/service';
import EnvironmentService from 'cio/services/environment';
import { ActionType } from 'cio/models/action';
import actionInfo from 'cio/utils/action-info';
import { Grouping } from 'cio/utils/metrics/resolution';

interface CampaignOverviewPageControlsArgs {
  campaign: CampaignModel;
  timeRange: DateRange;
  timePeriod: Periods;
  onRangeSelect: (range: DateRange, presetValue: string) => void;
  grouping: Grouping;
  onGroupingSelect: (grouping: Grouping) => void;
  channels: string[];
  onChannelsSelect: (channels: string[]) => void;
}

export default class CampaignOverviewControlsPage extends Component<CampaignOverviewPageControlsArgs> {
  @service environment!: EnvironmentService;

  get timeGroupings() {
    let isWeeklyTimePeriod = this.args.timePeriod === Periods.WEEKS;
    let isMonthlyTimePeriod = this.args.timePeriod === Periods.MONTHS;

    let timeGroupings = [
      { label: 'Daily', value: Grouping.Daily, disabled: isWeeklyTimePeriod || isMonthlyTimePeriod },
    ];

    let { timeRange } = this.args;

    let daysInRange = (timeRange.end?.diff(timeRange.start, 'days') ?? 0) + 1;

    if (daysInRange >= 7) {
      timeGroupings.push({ label: 'Weekly', value: Grouping.Weekly, disabled: isMonthlyTimePeriod });
    }

    if (daysInRange >= 62) {
      timeGroupings.push({ label: 'Monthly', value: Grouping.Monthly, disabled: isWeeklyTimePeriod });
    }

    return timeGroupings;
  }

  get channelDropdownGroups() {
    return [
      {
        label: 'All channels',
        value: 'all_channels',
        items: this.environment.availableChannelsForCampaign(this.args.campaign).map((typeName) => {
          let info = actionInfo(`${typeName}_action` as ActionType);

          return {
            label: info.name,
            value: typeName,
            icon: info.icon,
          };
        }),
      },
    ];
  }
}
